import React, { useState } from 'react';
import './VirtualCFO.css';

function BusinessAdvisory() {
  const [activeIndex, setActiveIndex] = useState(null);

  const offerings = [
    {
      title: 'Strategic Planning',
      content: [
        'Business model refinement',
        'Short-term and long-term strategic roadmaps',
        'Organizational restructuring advice',
        'Market entry & expansion strategies',
        'Board-level decision support'
      ]
    },
    {
      title: 'Financial Restructuring',
      content: [
        'Working capital and cash flow optimization',
        'Debt restructuring and refinancing advisory',
        'Cost control strategies and margin improvement',
        'Capital allocation planning'
      ]
    },
    {
      title: 'Performance & Risk Advisory',
      content: [
        'KPI identification and performance monitoring',
        'Operational risk assessment',
        'Business continuity and disaster recovery planning',
        'Enterprise risk management frameworks'
      ]
    },
    {
      title: 'Governance & Regulatory Advisory',
      content: [
        'Corporate governance structuring',
        'Policy design and documentation',
        'Support for statutory compliance and audits',
        'Process review and internal control enhancement'
      ]
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/advisory_hero.jpg')" }}
      >
        <div className="hero-text-container">
          <h1>Business Advisory Services</h1>
          <p>Insights and strategy to transform your business growth trajectory</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Strategic Business Insights</h2>
          <p>We support clients in making smarter decisions through financial planning, restructuring, and risk assessment.</p>
          <p>Our advisory approach blends tax, legal, and finance to help you build a scalable and sustainable business model.</p>
          <p>We guide CXOs and founders with high-impact data and actionable strategies.</p>
        </div>
      </section>

      {/* Accordion Section */}
      <section className="accordion-section">
        <h2>Our Offerings</h2>
        <div className="accordion-container">
          {offerings.map((item, index) => (
            <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
              <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                <span>{activeIndex === index ? '−' : '+'}</span> {item.title}
              </div>
              {activeIndex === index && (
                <div className="accordion-body">
                  <ul>
                    {item.content.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default BusinessAdvisory;


